import React from 'react'
import * as R from 'ramda'
import Icon from '../../IconV1'

import { Label, ListActionItem } from './styles'

const Component = ({ children, icon, ...rest }) => (
  <ListActionItem {...rest}>
    <Label>{children}</Label>
    {R.cond([
      [R.is(String), () => <Icon name={icon} />],
      [React.isValidElement, R.identity],
      [R.isNil, () => null],
    ])(icon)}
  </ListActionItem>
)

export default Component
